import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgText = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	shapeRendering: "geometricPrecision",
	textRendering: "geometricPrecision",
	imageRendering: "optimizeQuality",
	fillRule: "evenodd",
	clipRule: "evenodd",
	viewBox: "0 0 512 282.21",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "nonzero",
		d: "M379.62 282.21c-22.92 0-46.25-6.45-59.38-26.66-5.82-9.01-8.7-20.45-8.7-34.32 0-32.17 16.16-52.18 46.66-61.17 9.27-2.75 19.37-4.48 30.18-5.31 11.69-.9 21.09-2.05 28.25-3.32 7.09-1.34 12.27-3.2 15.47-5.63 7.44-5.62 5.64-17.61-1.53-22.69-8.84-6.11-24.84-5.72-33.56.39-4.48 3.13-7.23 7.92-8.12 14.38h-69.17c.9-12.72 4.93-24.49 12.15-35.23 24.8-37.07 85.04-41.89 124.01-30.35 30.07 8.68 56.12 29.85 56.12 63.4v143.25h-70.25v-29.4h-1.66c-12.87 24.12-34.05 32.66-60.47 32.66zm-297.87-3.26H0L92.11 0H195.6l92.04 278.95h-81.69l-15.1-53.37H96.84l-15.09 53.37zm93.05-110.07-26.05-92.05h-9.85l-26.03 92.05h61.93zm245.47 62.39c19.82-9.28 17.13-25.54 17.13-43.85-9.63 3.9-19.72 6.07-29.97 7.6-12.18 2.01-25.06 7.51-25.06 21.8 0 19.73 24.18 20.87 37.9 14.45z"
	})
});
export default SvgText;
